import React from 'react';
import { Stack, Inline } from '@/Components/ui/layout';
import { Heading } from '@/Components/ui/typography';
import { Label } from '@/Components/ui/label';

function OtherInformation({ otherInfo, setOtherInfo }) {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setOtherInfo((prev) => ({ ...prev, [name]: value }));
  };
  const formValues = {
    jobStatus: otherInfo?.jobStatus || '',
    workLocation: otherInfo?.workLocation || '',
    preferredLocation: otherInfo?.preferredLocation || '',
    companyStages: otherInfo?.companyStages || '',
    techSectors: otherInfo?.techSectors || '',
  };
  return (
    <section className="flex mt-10 w-full flex-col text-slate-300 font-normal text-center mr-[210px] ml-2">
      <Heading level="h2" size="3xl" className="py-2.5 self-start ml-1 self-center text-slate-300">
        Other Information
      </Heading>
      <form className="flex mt-7.5 w-full max-w-[1074px] flex-col items-center ml-4 mt-5">
        <Inline spacing="xl" className="w-full justify-between mb-7.5 gap-[160px]">
          <Stack spacing="xs" className="w-[42%] flex-col -mt-5">
            <Label htmlFor="jobStatus" className="self-start text-xl py-2.5">Current job seeking status</Label>
            <select
              id="jobStatus"
              name="jobStatus"
              className="rounded-lg h-auto w-full border border-slate-700 bg-transparent text-slate-400 py-4 px-4 text-lg mt-2.5 focus:border-green-400 focus:outline-none"
              value={formValues.jobStatus || ''}
              onChange={handleChange}
            >
              <option value="">Select status</option>
              <option value="actively-looking">Actively looking</option>
              <option value="open-to-opportunities">Open to opportunities</option>
              <option value="not-looking">Not looking</option>
            </select>
          </Stack>
          <Stack spacing="xs" className="w-[42%] flex-col -mt-5">
            <Label htmlFor="workLocation" className="self-start text-xl py-2.5">Where do you want to work?</Label>
            <select
              id="workLocation"
              name="workLocation"
              className="rounded-lg h-auto w-full border border-slate-700 bg-transparent text-slate-400 py-4 px-4 text-lg mt-2.5 focus:border-green-400 focus:outline-none"
              value={formValues.workLocation || ''}
              onChange={handleChange}
            >
              <option value="">Select country</option>
              <option value="dublin">Dublin</option>
              <option value="cork">Cork</option>
              <option value="galway">Galway</option>
              <option value="limerick">Limerick</option>
              <option value="waterford">Waterford</option>
              <option value="kerry">Kerry</option>
              <option value="donegal">Donegal</option>
              <option value="wicklow">Wicklow</option>
            </select>
          </Stack>
        </Inline>
        <Inline spacing="xl" className="w-full justify-between mb-7.5 gap-[160px]">
          <Stack spacing="xs" className="w-[42%] flex-col -mt-5">
            <Label htmlFor="preferredLocation" className="self-start text-xl py-2.5">What job location do you prefer?</Label>
            <select
              id="preferredLocation"
              name="preferredLocation"
              className="rounded-lg h-auto w-full border border-slate-700 bg-transparent text-slate-400 py-4 px-4 text-lg mt-2.5 focus:border-green-400 focus:outline-none"
              value={formValues.preferredLocation || ''}
              onChange={handleChange}
            >
              <option value="">Select location</option>
              <option value="dublin">Dublin</option>
              <option value="cork">Cork</option>
              <option value="galway">Galway</option>
              <option value="limerick">Limerick</option>
              <option value="waterford">Waterford</option>
              <option value="kerry">Kerry</option>
              <option value="donegal">Donegal</option>
            </select>
          </Stack>
          <Stack spacing="xs" className="w-[42%] flex-col -mt-5">
            <Label htmlFor="companyStages" className="self-start text-xl py-2.5">What company stages are you interested?</Label>
            <select
              id="companyStages"
              name="companyStages"
              className="rounded-lg h-auto w-full border border-slate-700 bg-transparent text-slate-400 py-4 px-4 text-lg mt-2.5 focus:border-green-400 focus:outline-none"
              value={formValues.companyStages || ''}
              onChange={handleChange}
            >
              <option value="">Select stages</option>
              <option value="seed">Seed</option>
              <option value="series-a">Series A</option>
              <option value="series-b">Series B</option>
              <option value="series-c">Series C</option>
              <option value="ipo">IPO</option>
            </select>
          </Stack>
        </Inline>
        <Inline spacing="xl" className="w-full justify-between mb-7.5 gap-[160px]">
          <Stack spacing="xs" className="w-[42%] flex-col -mt-5">
            <Label htmlFor="techSectors" className="self-start text-xl py-2.5">Which tech sectors are you interested in?</Label>
            <select
              id="techSectors"
              name="techSectors"
              className="rounded-lg h-auto w-full border border-slate-700 bg-transparent text-slate-400 py-4 px-4 text-lg mt-2.5 focus:border-green-400 focus:outline-none"
              value={formValues.techSectors || ''}
              onChange={handleChange}
            >
              <option value="">Select sectors</option>
              <option value="software">Software</option>
              <option value="hardware">Hardware</option>
              <option value="fintech">Fintech</option>
              <option value="healthtech">Healthtech</option>
              <option value="edtech">Edtech</option>
              <option value="agritech">Agritech</option>
              <option value="martech">Martech</option>
            </select>
          </Stack>
        </Inline>
      </form>
    </section>
  );
}

export default OtherInformation;
